module.exports = __webpack_public_path__ + "static/media/background.bf989778.webp";